import axios from 'axios';
import RestService from '../../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getTransactions() {
  try {
    const {data} = await axios.get('/api/transactions/get');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function syncTest() {
  try {
    const {data} = await axios.get('/api/translate/sync-test');
    if(data.errcode == 200) {
      return true;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}



export async function syncDemo() {
  try {
    const {data} = await axios.get('/api/translate/sync-demo');
    if(data.errcode == 200) {
      return true;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}




export async function syncProd() {
  try {
    const {data} = await axios.get('/api/translate/sync-prod');
    if(data.errcode == 200) {
      return true;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Transactions/actions.js